import { format } from "@/lib/numberFormatter";
import * as uuid from "uuid/v4";
import StaticEntity from "./StaticEntity.model";

const layerType = {
  ENTITY_MODEL: "EntityModelCard",
  ENTITY_PROP: "EntityPropertyModel",
  COMPUTED_PROP: "ComputedLayerCard",
  CATEGORICAL: "CategoricalFilter",
  SATIC_LAYER: "StaticLayer",
};
/**
 * Property layer of @EntityModelLayer
 * Contains the property of the entity and it's aggregation
 */
class EntityPropertyLayer {
  constructor({
    id,
    name,
    entity_model_id,
    property,
    aggregation,
    value,
    isEditable = true,
  }) {
    this.type = layerType.ENTITY_PROP;
    this.name = name;
    this.entity_model_id = entity_model_id;
    this.property = property;
    this.aggregation = aggregation;
    this.value = value;
    this.id = id || uuid();
    this.isEditable = isEditable;
  }

  /**
   * Returns the value of the layer
   */
  getvalue() {
    return this.value;
  }

  /**
   * Return the formatted value of the layer
   * if no value is presetn, returns null
   */
  getFormattedValue() {
    // Donot format if the value is null
    if (!this.value) return null;

    let value = parseFloat(this.value);
    value = isNaN(value) ? 0 : value;
    value = format(value.toFixed(0), 2);
    return value;
  }

  /**
   * Sets value of the property layer
   * @param {Number} value
   */
  setValue(value) {
    this.value = value;
  }
}

/**
 * The Entity layer property
 * Holds the details regarding the entity with it's filters
 */
class EntityModelLayer {
  /**
   *
   * @param LayerDetails details of the layer
   * @param LayerDetails.id Unique identifier of the layer, auto generated if null
   * @param LayerDetails.name Name of the layer, uses entity_name is null
   * @param LayerDetails.entity_id Entity id of the entity layer
   * @param LayerDetails.entity_name Enity name of the entity layer
   */
  constructor({
    id,
    name,
    entity_id,
    entity_name,
    entity_type,
    layers,
    isEditable = true,
  }) {
    this.type = layerType.ENTITY_MODEL;
    this.id = id || uuid();
    this.name = name;
    this.entity_id = entity_id;
    this.entity_name = entity_name;
    this.entity_type = entity_type;
    this.layers = layers || null;
    this.isEditable = isEditable;
  }
}

/**
 * Computed Property Layer
 * Creates a computed property using other entity properties
 */
class ComputedLayer {
  /**
   *
   * @param LayerDetails Details of the computed layer
   * @param LayerDetails.id Unique identifier of the layer, auto generated if null
   * @param LayerDetails.name Name of the layer
   * @param LayerDetails.variables List of All the Variable id of the computed layer
   * @param LayerDetails.expression String of Expression Defining the computed property
   */
  constructor({
    id,
    name,
    variables,
    expression,
    value,
    description,
    isEditable = true,
  }) {
    this.type = layerType.COMPUTED_PROP;
    this.id = id || uuid();
    this.name = name;
    this.variables = variables;
    this.expression = expression;
    this.value = value;
    this.description = description;
    this.isEditable = isEditable;
  }

  getValue() {
    return this.value;
  }

  setValue(value) {
    this.value = value;
  }
}

/**
 * Layer for static entities
 * Static Layer
 */

class StaticLayer {
  /**
   *
   * @param {Object} param
   * @param {String} param.id Id of the entity
   * @param {String} param.name Name of the entity
   * @param {Array[StaticEntity]} param.entities List of all the enitites
   */
  constructor({ id, name, entities }) {
    this.id = id;
    this.name = name;
    this.entities = entities;
  }
}
export {
  ComputedLayer,
  EntityModelLayer,
  EntityPropertyLayer,
  StaticLayer,
  layerType,
};
